import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%'
  },

  logo: {
    borderRadius: '50%',
    padding: '0.5rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },

  img: {
    width: '36px',
    height: '36px',
    position: 'relative'
  },

  background: {
    height: '50px',
    width: '50px',
    position: 'absolute'
  }
}))

export default useStyles
